const ACCESS_KEY = "accessTkn";
const REFRESH_KEY = "refreshTkn";

const getLocalAccessToken = () => localStorage.getItem(ACCESS_KEY);
const getLocalRefreshToken = () => localStorage.getItem(REFRESH_KEY);
const updateLocalAccessToken = (token) =>
  localStorage.setItem(ACCESS_KEY, token);
const updateLocalRefreshToken = (token) =>
  localStorage.setItem(REFRESH_KEY, token);
const removeTokens = () => {
  localStorage.removeItem(ACCESS_KEY);
  localStorage.removeItem(REFRESH_KEY);
};

const TokenService = {
  getLocalAccessToken,
  getLocalRefreshToken,
  updateLocalAccessToken,
  updateLocalRefreshToken,
  removeTokens,
};

export default TokenService;
